<template>
  <section class="flex flex-col lg:flex-row h-full w-full py-15vw lg:py-0 lg:px-10vw bg-black-60 overflow-auto">
    <div class="lg:flex-c lg:w-1/3 px-5vw lg:pl-0 lg:pr-5vw lg:pb-5vw">
      <div class="w-full">
        <h1
          class="text-white mb-3 md:mb-6 text-xl md:text-3xl font-bold uppercase leading-tight font-graphik"
          v-html="post.title"
        />
        <p
          class="mb-5 md:mb-8 font-light text-white font-graphiklight"
          v-html="post.description"
        />
        <a
          :href="utmHref(post.linkout, 'tier-2-cta')"
          target="_blank"
          class="inline-block px-6 py-4 btn--primary focus-a"
        >
          {{ post.cta }}

          <svg xmlns="http://www.w3.org/2000/svg" width="36" height="32" viewBox="0 0 36 32" v-bind:svg-inline="''" v-bind:class="'inline-block h-4 w-4 -mt-1 ml-1 fill-current'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M36 1.5v7.999a1.501 1.501 0 01-2.561 1.06l-2.232-2.232-15.221 15.22c-.271.271-.646.439-1.061.439s-.789-.168-1.061-.439l-1.414-1.414c-.271-.271-.439-.646-.439-1.061s.168-.789.439-1.061L27.671 4.792 25.44 2.56a1.5 1.5 0 011.059-2.561h8c.828 0 1.499.671 1.499 1.499v.001zM25.439 16.925l-1.003 1.003a1.5 1.5 0 00-.438 1.055v9.018H4V8h16.502c.413 0 .788-.167 1.059-.438l1.003-1.003a1.5 1.5 0 00-1.06-2.56H3a3 3 0 00-3 3V29a3 3 0 003 3h22.002a3 3 0 003-3V17.985v-.001a1.5 1.5 0 00-2.563-1.059z"/></svg>
        </a>
      </div>
    </div>

    <div class="mb-4 lg:mb-0 lg:flex-c lg:w-2/3 order-first lg:order-last">
      <RvVideo
        :post="post"
      />
    </div>
  </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import RvVideo from '@/components/RvVideo.vue'

export default {
  name: 'Video',

  components: {
    RvVideo
  },

  props: {
    post: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    ...mapState([ 'touch', 'mobile' ]),
    ...mapGetters([ ])
  }
}
</script>
